import { render, staticRenderFns } from "./BtnTimed.vue?vue&type=template&id=022829df&"
import script from "./BtnTimed.vue?vue&type=script&lang=ts&"
export * from "./BtnTimed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports